exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-count{border-radius:100px;background-color:#f05323;padding:2px 4px 2px 4px}.uig-button .badge-count{background-color:#fff;color:#f05323}.brand-TP .uig-button .badge-count{color:black}\n", ""]);

// exports
